import { useState, useEffect } from 'react';
import UserStorageService from 'services/UserStorageService';

/**
 * Hook para acceder a los datos del usuario actual
 * Reemplazo para useLocalStorage('me') que incluye validación y auto-refresh
 */
export const useCurrentUser = () => {
	const [user, setUser] = useState(() => UserStorageService.getUser());

	useEffect(() => {
		// Función para actualizar el estado cuando cambie el localStorage
		const handleStorageChange = () => {
			setUser(UserStorageService.getUser());
		};

		// Escuchar cambios en localStorage
		window.addEventListener('storage', handleStorageChange);

		// También escuchar eventos custom para cambios internos
		window.addEventListener('userDataUpdated', handleStorageChange);

		// Limpiar listeners
		return () => {
			window.removeEventListener('storage', handleStorageChange);
			window.removeEventListener('userDataUpdated', handleStorageChange);
		};
	}, []);

	return [user, setUser];
};

/**
 * Función helper para notificar cambios en los datos del usuario
 * Debe llamarse cuando se actualicen los datos del usuario internamente
 */
export const notifyUserDataUpdated = () => {
	window.dispatchEvent(new Event('userDataUpdated'));
};

export default useCurrentUser;
